// Direct sponsor ids that should be exempt from MA-group suppression

import { env } from '@pass-frontend/features/configuration/util';

// (in addition to any sponsor id containing 'MedSupp').
const SUPPRESSED_SPONSOR_IDS = new Set<string>([
  // include prod users
  '1fabc539-a5c1-4d44-a64e-7a79d89dbcf0',
]);

// Supressing online event and AARP Staying Sharp promos for MA-group sponsors (unless sponsor is Medsupp)
export const SUPPRESSED_PROMOS = new Set<string>([
  'Online Events',
  'AARP Staying Sharp',
]);

// Supressing Stay Focused and stay connected pages for MA-group sponsors (unless sponsor is Medsupp)
export const SUPPRESSED_PAGES = new Set(['Stay Focused', 'Stay Connected']);

export enum SponsorType {
  MA = 'MA',
  MedSupp = 'MedSupp',
  NotValid = 'NotValid',
}

// Getting whether a sponsor is MA-group or MedSupp based on the sponsorId. If the sponsorId is not valid or feature flag is not on, return 'NotValid'.
export const clientInformation = (sponsorId?: string | null): SponsorType => {
  const FF_SUPPRESS_FOR_MAGROUP = env().FF_SUPPRESS_FOR_MAGROUP;
  if (!sponsorId) return SponsorType.NotValid;
  if (!FF_SUPPRESS_FOR_MAGROUP) return SponsorType.NotValid;
  if (sponsorId.includes('MedSupp') || SUPPRESSED_SPONSOR_IDS.has(sponsorId)) {
    return SponsorType.MedSupp;
  } else return SponsorType.MA;
};
